var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBekleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FFCC24"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_535_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2213 10.6644C16.631 10.0024 16.8564 9.24294 16.8739 8.46459C16.8914 7.68625 16.7005 6.91737 16.321 6.23762C15.9414 5.55787 15.387 4.99197 14.7152 4.59854C14.0433 4.20512 13.2785 3.99848 12.5 4.00004H8.125C7.79348 4.00004 7.47554 4.13174 7.24112 4.36616C7.0067 4.60058 6.875 4.91852 6.875 5.25004V17.75C6.875 18.0816 7.0067 18.3995 7.24112 18.6339C7.47554 18.8683 7.79348 19 8.125 19H14.375C15.3709 19.0011 16.3373 18.6621 17.1142 18.039C17.8912 17.416 18.4321 16.5464 18.6475 15.5741C18.8628 14.6017 18.7397 13.585 18.2985 12.6922C17.8573 11.7994 17.1244 11.084 16.2213 10.6644V10.6644ZM9.375 6.50004H12.5C12.9973 6.50004 13.4742 6.69758 13.8258 7.04921C14.1775 7.40084 14.375 7.87776 14.375 8.37504C14.375 8.87232 14.1775 9.34923 13.8258 9.70086C13.4742 10.0525 12.9973 10.25 12.5 10.25H9.375V6.50004ZM14.375 16.5H9.375V12.75H14.375C14.8723 12.75 15.3492 12.9476 15.7008 13.2992C16.0525 13.6508 16.25 14.1278 16.25 14.625C16.25 15.1223 16.0525 15.5992 15.7008 15.9509C15.3492 16.3025 14.8723 16.5 14.375 16.5V16.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_535_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBekleIcon);
export default __webpack_public_path__ + "static/media/bekle_icon.f6fc7c7a66f60d4272b911f02aba1763.svg";
export { ForwardRef as ReactComponent };